import ACTIONS from "./CronSettingsActionTypes";

const initialState = {
  getCronReminderEmailsListLoading: false,
  getCronReminderEmailsListResponse: [],
  getCronSettingsListLoading: false,
  getCronSettingsListResponse: null,
  postCronSettingsLoading: false,
  postCronSettingsResponse: null,
  deleteCronSettingsLoading: false,
  deleteCronSettingsResponse: null,
};

const CronSettingReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.GET_CRON_REMINDER_EMAILS_LIST_REQUEST:
      return {
        ...state,
        getCronReminderEmailsListLoading: true,
      };
    case ACTIONS.GET_CRON_REMINDER_EMAILS_LIST_RESPONSE:
      return {
        ...state,
        getCronReminderEmailsListLoading: false,
        getCronReminderEmailsListResponse: action.payload,
      };
    case ACTIONS.GET_CRON_SETTINGS_LIST_REQUEST:
      return {
        ...state,
        getCronSettingsListLoading: true,
      };
    case ACTIONS.GET_CRON_SETTINGS_LIST_RESPONSE:
      return {
        ...state,
        getCronSettingsListLoading: false,
        getCronSettingsListResponse: action.payload.data,
      };
    case ACTIONS.POST_CRON_SETTINGS_REQUEST:
    case ACTIONS.PUT_CRON_SETTINGS_REQUEST:
    case ACTIONS.PUT_STATUS_CRON_SETTINGS_REQUEST:
      return {
        ...state,
        postCronSettingsLoading: true,
      };
    case ACTIONS.POST_CRON_SETTINGS_RESPONSE:
    case ACTIONS.PUT_CRON_SETTINGS_RESPONSE:
    case ACTIONS.PUT_STATUS_CRON_SETTINGS_RESPONSE:
      return {
        ...state,
        postCronSettingsLoading: false,
        postCronSettingsResponse: action.payload,
      };
    case ACTIONS.POST_CRON_SETTINGS_RESPONSE_CLEAR:
      return {
        ...state,
        postCronSettingsResponse: null,
      };
    case ACTIONS.DELETE_CRON_SETTINGS_REQUEST:
      return {
        ...state,
        deleteCronSettingsLoading: true,
      };
    case ACTIONS.DELETE_CRON_SETTINGS_RESPONSE:
      return {
        ...state,
        deleteCronSettingsLoading: false,
        deleteCronSettingsResponse: action.payload,
      };
    case ACTIONS.DELETE_CRON_SETTINGS_RESPONSE_CLEAR:
      return {
        ...state,
        deleteCronSettingsResponse: null,
      };
    default:
      return state;
  }
};

export default CronSettingReducer;
